import React, { useState, useRef } from 'react';
import styles from './SistemaExterno.module.css';

function IframeApp({ nome, url }) {
  const [carregando, setCarregando] = useState(true);
  const iframeRef = useRef(null);

  /* Sem URL configurada — placeholder para integração futura */
  if (!url) {
    return (
      <div className={styles.placeholder}>
        <div className={styles.placeholderCard}>
          <div className={styles.placeholderIcone}>
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <rect x="2" y="3" width="20" height="14" rx="2"/>
              <path d="M8 21h8M12 17v4"/>
            </svg>
          </div>
          <h2 className={styles.placeholderTitulo}>{nome}</h2>
          <p className={styles.placeholderDesc}>
            Sistema externo aguardando configuração de URL.
          </p>
          <div className={styles.placeholderInstrucao}>
            <span className={styles.placeholderLabel}>Configure no .env do frontend:</span>
            <code className={styles.placeholderCode}>
              REACT_APP_{nome.toUpperCase()}_URL=https://seu-sistema.railway.app
            </code>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.wrapper}>
      {carregando && (
        <div className={styles.loading}>
          <div className={styles.spinner} />
          <span>Carregando {nome}...</span>
        </div>
      )}
      <iframe
        ref={iframeRef}
        src={url}
        title={nome}
        className={styles.iframe}
        style={{ opacity: carregando ? 0 : 1 }}
        onLoad={() => setCarregando(false)}
        allow="fullscreen"
      />
    </div>
  );
}

export default IframeApp;
